import axios from 'axios';
import apiUrl from '../configs/constant';

export const getDoctag = async (menu: number, cabang: number, token: string) => {
  try {
    const url = `${apiUrl.apiUrl}/system/doctag/list-combo?sysmenu_id=${menu}`;
    const response = await axios.get(url, {
      params: {
        syscabang_id: cabang,
        sysmenu_id: menu, // sepertinya sysmenu_id tetap menu
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.data.success) {
      return response.data.data; // kembalikan datanya
    } else {
      throw new Error(response.data.message);
    }
  } catch (error: any) {
    console.error('Error fetching doctag:', error);
    throw error;
  }
};
export const getGudang = async (token: string) => {
  try {
    const url = `${apiUrl.apiUrl}/mm/gudang/list-combo`;
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.data.success) {
      return response.data.data; // kembalikan datanya
    } else {
      throw new Error(response.data.message);
    }
  } catch (error: any) {
    console.error('Error fetching gudang:', error);
    throw error;
  }
};

export const getPeriode = async (token: string) => {
  try {
    const url = `${apiUrl.apiUrl}/acc/laporan-keuangan/list-combo-periode`;
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.data.success) {
      return response.data.data; // kembalikan datanya
    } else {
      throw new Error(response.data.message);
    }
  } catch (error: any) {
    console.error('Error fetching gudang:', error);
    throw error;
  }
};
export const getGudangJadi = async (token: string) => {
  try {
    const url = `${apiUrl.apiUrl}/mm/gudang/list-combo-gudang-jadi`;
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.data.success) {
      return response.data.data; // kembalikan datanya
    } else {
      throw new Error(response.data.message);
    }
  } catch (error: any) {
    console.error('Error fetching gudang:', error);
    throw error;
  }
};

export const getCustomer = async (token: string) => {
  try {
    const url = `${apiUrl.apiUrl}/sales/customer/list-combo`;
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.data.success) {
      return response.data.data; // kembalikan datanya
    } else {
      throw new Error(response.data.message);
    }
  } catch (error: any) {
    console.error('Error fetching gudang:', error);
    throw error;
  }
};
export const getSales = async (token: string) => {
  try {
    const url = `${apiUrl.apiUrl}/sales/salesman/list-combo`;
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.data.success) {
      return response.data.data; // kembalikan datanya
    } else {
      throw new Error(response.data.message);
    }
  } catch (error: any) {
    console.error('Error fetching gudang:', error);
    throw error;
  }
};

export const getProduct = async (token: string) => {
  try {
    const url = `${apiUrl.apiUrl}/sales/quotation/list-product`;
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.data.success) {
      return response.data.data; // kembalikan datanya
    } else {
      throw new Error(response.data.message);
    }
  } catch (error: any) {
    console.error('Error fetching gudang:', error);
    throw error;
  }
};

export const getProses = async (token: string) => {
  try {
    const url = `${apiUrl.apiUrl}/production/work-order/list-combo-proses`;
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.data.success) {
      return response.data.data; // kembalikan datanya
    } else {
      throw new Error(response.data.message);
    }
  } catch (error: any) {
    console.error('Error fetching gudang:', error);
    throw error;
  }
};

export const getProsesBorongan = async (token: string) => {
  try {
    const url = `${apiUrl.apiUrl}/production/work-order/list-combo-proses-borongan`;
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.data.success) {
      return response.data.data; // kembalikan datanya
    } else {
      throw new Error(response.data.message);
    }
  } catch (error: any) {
    console.error('Error fetching gudang:', error);
    throw error;
  }
};

export const getDesigner = async (cabang: number,token: string) => {
  try {
    const url = `${apiUrl.apiUrl}/production/work-order/list-designer`;
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.data.success) {
      return response.data.data; // kembalikan datanya
    } else {
      throw new Error(response.data.message);
    }
  } catch (error: any) {
    console.error('Error fetching gudang:', error);
    throw error;
  }
};

export const getSite = async (cabang: number,token: string) => {
  try {
    const url = `${apiUrl.apiUrl}/production/work-order/list-site`;
    const response = await axios.get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.data.success) {
      return response.data.data; // kembalikan datanya
    } else {
      throw new Error(response.data.message);
    }
  } catch (error: any) {
    console.error('Error fetching gudang:', error);
    throw error;
  }
};